import { filter } from "graphql-anywhere";
import curry from "./curry";
import binary from "./binary";

const queryFilter = curry(binary(filter));

export default queryFilter;
